import {
  AppBar,
  Button,
  Container,
  Drawer,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import { useTranslation } from "react-i18next";

import { triggerDebuggerAndThrow } from "../../../utils/debugging-utils";
import FloatingActionButton from "../../Utilities/FloatingActionButton";
import ExercisesAddComponent from "../Add";
import ExerciseDetailsComponent from "../Details";
import ExercisesEditComponent from "../Edit";
import { ExerciseList } from "./ExerciseList";

const drawerWidth = 480;

const useStyles = makeStyles((theme) => ({
  exerciseFabListH5: {
    color: "black",
    marginTop: 25,
    fontSize: 14,
    textTransform: "capitalize",
    fontWeight: "bold",
  },
  exerciseFabListPaper: {
    display: "flex",
    backgroundColor: "#3e7fe9",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15,
    padding: 15,
    cursor: "pointer",
  },
  appBar1: {
    width: drawerWidth,
    backgroundColor: "rgb(62, 127, 233)",
  },
  drawerPaper: {
    width: drawerWidth,
    overflowX: "hidden",
  },
  exerciseFabListToolBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  exerciseFabListToolBar2: {
    display: "flex",
    alignItems: "center",
    width: "75%",
  },
  exerciseFabListEditBtn: {
    height: "fit-content",
    background: "white",
    borderRadius: 30,
    width: "fit-content",
    zIndex: 1,
    marginLeft: "auto",
  },
}));

export default function ExerciseListPage(props: any) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [myTab, setMyTab] = React.useState(false);
  const [myMyExe, setMyExe] = React.useState(false);
  const [handleExedrawers, sethandleExedrawers] = React.useState(false);
  const [exedrawers, setExedrawers] = React.useState({
    id: "",
    name: "",
    state: false,
  });

  const drawerProps = {
    myTab,
    setMyTab,
    myMyExe,
    setMyExe,
    handleExedrawers,
    sethandleExedrawers,
    exedrawers,
    setExedrawers,
  };

  return (
    <Container>
      <ExerciseList {...props} {...drawerProps}>
        {!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && (
          <div style={{ height: "fit-content", width: "30%" }}>
            <h5 className={`${classes.exerciseFabListH5}`}>{/* {t("Action")} */}</h5>
            <Paper
              onClick={(_) => sethandleExedrawers(true)}
              className={classes.exerciseFabListPaper}
            >
              <span style={{ color: "#ffffff" }}>{t("Add exercise")}</span>
              <AddIcon style={{ color: "#ffffff" }} />
              {/* <FaPlus
    color="#ffffff"
    /> */}
            </Paper>
          </div>
        )}
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="right"
          open={handleExedrawers}
          onClose={(_) => sethandleExedrawers(false)}
        >
          <AppBar className={classes.appBar1} style={{ position: "initial" }}>
            <Toolbar>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <IconButton onClick={(_) => sethandleExedrawers(false)}>
                      <ArrowBackIcon style={{ color: "#ffffff" }} />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                      {t("Add exercise")}
                    </Typography>
                  </div>
                </div>
              </div>
            </Toolbar>
          </AppBar>
          <div style={{ margin: "2rem 22px 0" }}>
            <ExercisesAddComponent />
          </div>
        </Drawer>

        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="right"
          open={exedrawers.state}
          onClose={(_) => {
            setMyExe(false);
            setExedrawers({ ...exedrawers, state: false });
          }}
        >
          <AppBar className={classes.appBar1} style={{ position: "initial" }}>
            <Toolbar>
              <div className={classes.exerciseFabListToolBar}>
                <div
                  className={`d-flex align-items-center w-75 ${classes.exerciseFabListToolBar2}`}
                >
                  <IconButton
                    onClick={(_) => {
                      setMyExe(false);
                      setExedrawers({ ...exedrawers, state: false });
                    }}
                  >
                    <ArrowBackIcon style={{ color: "#ffffff" }} />
                  </IconButton>
                  <Typography variant="h6" noWrap>
                    {exedrawers.name}
                  </Typography>
                </div>
                {myTab && (
                  <div style={{ display: "flex", width: "25%" }}>
                    <Button
                      variant="contained"
                      className={classes.exerciseFabListEditBtn}
                      size="small"
                      onClick={(_) => setMyExe(true)}
                      // startIcon={<FaPencilAlt />}
                    >
                      <span
                        style={{
                          textTransform: "capitalize",
                          fontWeight: "bold",
                        }}
                      >
                        <EditIcon style={{ fontSize: 15 }} />
                        {t("Edit")}
                      </span>
                    </Button>
                  </div>
                )}
              </div>
            </Toolbar>
          </AppBar>
          {myMyExe ? (
            <div className="p-3">
              <ExercisesEditComponent drawerId={exedrawers.id} setMyExe={setMyExe} />
            </div>
          ) : (
            <ExerciseDetailsComponent drawerId={exedrawers} />
          )}
        </Drawer>
        {/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) && (
          <FloatingActionButton
            onClick={() => props.history.push("/exercises/add")}
            /* These should all be moved out, of course */
            onAddSuperset={triggerDebuggerAndThrow}
            onAddExercise={triggerDebuggerAndThrow}
            onAdd={triggerDebuggerAndThrow}
            onInvite={triggerDebuggerAndThrow}
            show={true}
            options={[]}
          />
        )}
      </ExerciseList>
    </Container>
  );
}
